import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-price-breakdown',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './price-breakdown.component.html',
  styleUrls: ['./price-breakdown.component.scss']
})
export class PriceBreakdownComponent implements OnInit {

  @Input()
  price;

  @Input()
  timeslot;

  @Input()
  amendType;

  @Input()
  bookingABC;

  @Input()
  appCopy;

  @Input()
  selectedLanguage;

  @Input()
  languageCode;

  @Input()
  premiumSurcharge;

  public pricingBreakdown = null;

  constructor() { }

  ngOnInit() {
    // console.log(this.languageCode)
   }

}
